module.exports = __webpack_public_path__ + "static/media/class (7).b59d6266.webp";